import Navigator from '../../../components/common/Navigator'
import Img1 from '../../../assets/LearningNew.jpg'
import ProgramShedules from './program/Programs'
import FormBuilder from '../../../components/app/formBuilder'
import { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import Icons from '../../../components/common/icons'

export const ROLE_DISPLAY_NAME: Record<number, string> = {
  2: 'Aspiring Entrepreneur',
  3: 'School',
  4: 'Research Scholar',
  5: 'Existing Entrepreneur',
  6: 'Industry Association',
  7: 'Mentor',
  8: 'Entrepreneurship Club',
  9: 'Student',
  10: 'Guest',
}

interface FormFilters {
  applicant?: string
  status?: 'Upcoming' | 'Current' | 'Completed'
  fee_type?: 'free' | 'paid'
  duration?: string
  financial_year?: string
  start_date?: string
  end_date?: string
  certification?: 'certified' | 'not_certified'
}

interface ApiFilters {
  applicant_id?: string
  start_date?: string
  end_date?: string
  status?: string
  fee_type?: string
  duration?: string
  financial_year?: string
  certification?: string
}
type SelectOption = { id: string; name: string }

export default function TrainingCalendar() {
  const methods = useForm<FormFilters>({
    defaultValues: {
      status: 'Current',
    },
  })
  const formValues = methods.watch()
  const [filters, setFilters] = useState<ApiFilters>({})
  const [showInfo, setShowInfo] = useState(false)

  const formatDate = (date: string) => {
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const handleFilterChange = (formFilters: FormFilters) => {
    const apiFilters: ApiFilters = {}

    const getIdValue = (fieldName: string, value: any) => {
      const fieldConfig = filterFields.find((f) => f.name === fieldName)
      if (fieldConfig?.descId && typeof value === 'string') {
        const match = (fieldConfig.data as SelectOption[])?.find(
          (d) => d[fieldConfig.desc as keyof SelectOption] === value
        )
        return match ? match[fieldConfig.descId as keyof SelectOption] : value
      }
      if (value && typeof value === 'object') {
        return value[fieldConfig?.descId || 'id']
      }
      return value
    }

    apiFilters.applicant_id = getIdValue('applicant', formFilters.applicant)
    apiFilters.status = getIdValue('status', formFilters.status)

    // ✅ Map "current" filter to "ongoing" API value
    // if (formFilters.status === 'current') {
    //   apiFilters.status = 'ongoing'
    // }
    // ✅ Map "current" filter to "ongoing" API value
    // if (formFilters.status === 'current') {
    //   apiFilters.status = 'ongoing'
    // }
    if (apiFilters.status === 'Current') {
      apiFilters.status = 'ongoing'
    }

    apiFilters.fee_type = getIdValue('fee_type', formFilters.fee_type)
    apiFilters.certification = getIdValue(
      'certification',
      formFilters.certification
    )
    apiFilters.financial_year = getIdValue(
      'financial_year',
      formFilters.financial_year
    )

    if (formFilters.start_date)
      apiFilters.start_date = formatDate(formFilters.start_date)
    if (formFilters.end_date)
      apiFilters.end_date = formatDate(formFilters.end_date)

    apiFilters.duration = formFilters.duration || undefined

    const cleanFilters = Object.fromEntries(
      Object.entries(apiFilters).filter(
        ([, value]) => value !== undefined && value !== null && value !== ''
      )
    )

    setFilters(cleanFilters)
  }

  const keyActivities = [
    {
      title: 'Entrepreneurship Capacity Building',
      points: [
        'Empretec (UNCTAD)',
        'Start And Generate Your Business (SYB & GYB) (ILO)',
        'Improve Your Business (IYB) (ILO)',
      ],
      description:
        'Conducts Entrepreneurship Development Programs for aspiring entrepreneurs, small business owners, and self-help groups. Delivers internationally recognized training modules such as:',
    },
    {
      title: 'Government Officer Training',
      points: [
        'Induction and Refresher Training',
        'Leadership and Management Development Programs',
        'Exposure Visits and Thematic Workshops',
      ],
      description:
        'Organizes training for officers of the Industries Department (from Industry Extension Officers to Joint Directors) including:',
    },
    {
      title: 'Youth & Academic Initiatives',
      points: [
        'Supports the formation and operation of Entrepreneurship Development Clubs (ED Clubs) in schools and colleges.',
        'Implements YUVA Bootcamps — a hands-on entrepreneurship training program that includes mentoring, ideation, business modeling, and pitching competitions.',
      ],
    },
    {
      title: 'Other Department Training',
      points: [
        'Organizes training for the staff and officers of the Kerala Khadi & Village Industries Board, Kerala State Financial Enterprises, Kerala State Development Corporation for SC & ST, etc.',
      ],
    },
    {
      title: 'Certification and Online Learning',
      points: [
        'Offers a Certificate Programme in Entrepreneurship in partnership with EDII Ahmedabad, with a focus on practical, Malayalam-language online learning.',
        'Provides structured modules on opportunity identification, business planning, compliance, and startup execution.',
      ],
    },
    {
      title: 'Inclusive Entrepreneurship Promotion',
      points: [
        'Tribal and Rural Entrepreneurs',
        'Women Entrepreneurs',
        'Widows and Differently-Abled Individuals',
        'Workers in traditional sectors like coir, handloom, and handicrafts',
      ],
      description: 'Conducts specialized training For:',
    },
    {
      title: 'Sector-Focused Interventions',
      points: [
        'Facilitates training and incubation support for enterprises in food processing, renewable energy, apparel, and related sectors.',
      ],
    },
  ]

  const filterFields = [
    {
      name: 'applicant',
      type: 'custom_select',
      placeholder: 'Applicant',
      tagline: 'Select the applicant role to filter trainings',
      desc: 'name',
      descId: 'id',
      isMultiple: false,
      data: Object.entries(ROLE_DISPLAY_NAME).map(([id, name]) => ({
        id,
        name,
      })),
    },
    {
      name: 'start_date',
      type: 'date',
      placeholder: 'Start Date',
      tagline: 'Choose the start date of the training',
      isRange: true,
    },
    {
      name: 'end_date',
      type: 'date',
      placeholder: 'End Date',
      isRange: true,
      tagline: 'Choose the end date of the training',
    },
    {
      name: 'status',
      type: 'custom_select',
      placeholder: 'Status',
      tagline: 'Filter trainings by their current status',

      desc: 'name',
      descId: 'id',
      id: 'status',
      data: [
        { name: 'Upcoming', id: 'Upcoming' },
        { name: 'Current', id: 'Current' },
        { name: 'Completed', id: 'Completed' },
      ],
    },
    {
      name: 'fee_type',
      type: 'custom_select',
      desc: 'name',
      descId: 'id',
      id: 'fee_type',
      placeholder: 'Fee Type',
      tagline: 'Filter trainings by free or paid',

      data: [
        { name: 'Free', id: 'free' },
        { name: 'Paid', id: 'paid' },
      ],
    },
    {
      name: 'duration',
      type: 'text',
      placeholder: 'Duration',
      tagline: 'Specify duration (e.g., 3 days, 1 week)',
    },
    {
      name: 'financial_year',
      type: 'custom_select',
      placeholder: 'Financial Year',
      tagline: 'Filter trainings by financial year',
      desc: 'name',
      descId: 'id',
      id: 'financial_year',
      data: [
        { name: '2021-2022', id: '2021-2022' },
        { name: '2022-2023', id: '2022-2023' },
        { name: '2023-2024', id: '2023-2024' },
        { name: '2024-2025', id: '2024-2025' },
        { name: '2025-2026', id: '2025-2026' },
        { name: '2026-2027', id: '2026-2027' },
        { name: '2027-2028', id: '2027-2028' },
      ],
    },
    {
      name: 'certification',
      type: 'custom_select',
      placeholder: 'Certification Status',
      tagline: 'Filter trainings by certification status',
      desc: 'name',
      descId: 'id',
      id: 'certification',
      data: [
        { name: 'Certified', id: 'certified' },
        { name: 'Not Certified', id: 'not_certified' },
      ],
    },
  ]
  useEffect(() => {
    handleFilterChange(formValues)
  }, [])

  useEffect(() => {
    handleFilterChange(formValues)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(formValues)])

  return (
    <div className="lg:w-11/12 lg:mx-auto mx-4  py-6 font-sans">
      {/* Header */}
      <div className="pb-4">
        <Navigator slug="LEARNING" title="Learning" />
        <h1 className="text-3xl font-semibold text-gray-900">Learning</h1>
        <p className="text-md text-gray-900 mt-1 pb-4">
          Curated programs, expert sessions, and hands-on training to upskill
          every step of your startup journey.
        </p>
        <hr className="border-t-2 border-primaryBlue " />
      </div>

      {/* Role and Function */}
      <div className="flex flex-col lg:flex-row items-center gap-6">
        <div className="flex-1 mb-[30px]">
          <div className="text-[24px] font-semibold text-gray-900 mb-2">
            Role and Function
          </div>
          <p className="text-md text-gray-900 mb-2 text-justify">
            The Learning Department of KIED serves as the knowledge and
            capacity-building wing of the institute. Its primary role is to
            design, coordinate, and implement training programs that nurture
            Entrepreneurial skills, promote innovation, and build institutional
            capacities across the state. It acts as a catalyst in creating a
            robust entrepreneurship ecosystem by empowering individuals,
            educational institutions, industry officials, and special target
            groups.
          </p>
          <p className="text-md text-gray-900 text-justify">
            The department bridges the gap between policy and implementation by
            delivering customized learning interventions aligned with the
            evolving needs of entrepreneurs, startups, and government
            stakeholders.
          </p>
        </div>
        <div className="flex-1 w-full">
          <img
            src={Img1}
            alt="Industry Academia Collaboration"
            className="rounded-lg object-cover w-full max-h-[300px] lg:max-h-none"
          />
        </div>
      </div>

      {/* Objectives */}
      <div className="">
        <div className="text-[24px] font-semibold text-gray-800 mb-3">
          Objectives
        </div>
        {/* <hr className="border-t-2 border-primaryBlue w-1/2 mb-4" /> */}
        <ul className="space-y-3 text-gray-900">
          {[
            'To instill an entrepreneurial mindset among students, youth, and early-stage entrepreneurs.',
            'To build the capacity of government officials, trainers, and mentors to support enterprise development.',
            'To promote inclusive entrepreneurship through targeted training for women, marginalized communities, and rural populations.',
            'To support sector-specific entrepreneurship, especially in areas like agro-processing, renewable energy, and traditional industries.',
            'To create sustainable platforms for entrepreneurial learning through academic programs and digital initiatives.',
          ].map((objective, index) => (
            <li key={index} className="flex items-start gap-2">
              <span className="text-primaryBlue text-lg">▶</span>
              <span>{objective}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Key Activities */}
      <div className="mt-12 ">
        <h2 className="text-[24px] font-semibold text-gray-800 mb-6">
          Key Activities
        </h2>
        <div className="grid grid-cols-1 xs:grid-cols-1 md:grid-cols-3 laptop:grid-cols-4 gap-6">
          {keyActivities.map((activity, index) => (
            <div
              key={index}
              className="bg-[#F7EEEE] rounded-xl shadow-md p-6 text-sm text-gray-900 leading-relaxed w-full h-auto"
            >
              <h3 className="text-[20px] font-semibold mb-3">
                {activity.title}
              </h3>
              {activity.description && (
                <p className="text-[16px] mb-3">{activity.description}</p>
              )}
              <ul className="space-y-2">
                {activity.points.map((point, idx) => (
                  <li key={idx} className="flex gap-2 items-start pl-5">
                    <span className="text-primaryBlue text-base mt-0.5">
                      ▶
                    </span>
                    <span className="text-[14px]">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Filters */}
      <div className="mt-10 mb-6 w-full relative bg-white border border-gray-200 rounded-lg shadow-sm p-4 hover:border-indigo-300">
        <div className="flex justify-between items-center mb-8 border-b border-blue-200/50 pb-4">
          <h3 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
            <span className="p-2 bg-blue-100 rounded-full transition-all duration-300 group-hover:bg-indigo-100">
              <Icons
                name="filter-icon"
                className="w-6 h-6 text-blue-600 group-hover:text-indigo-600"
              />
            </span>
            <span className="relative">
              Filters
              <span className="absolute -bottom-1 left-0 w-2/3 h-[3px] bg-gradient-to-r from-blue-500 to-blue-300 rounded-full transition-all duration-300 group-hover:from-indigo-500 group-hover:to-indigo-300"></span>
            </span>
          </h3>

          <button
            onClick={() => setShowInfo((prev) => !prev)}
            className={`p-2 rounded-full border border-blue-200 transition-all duration-300 shadow-sm 
        ${
          showInfo
            ? 'bg-indigo-100 text-indigo-700 rotate-180 border-indigo-200'
            : 'text-blue-500 hover:bg-indigo-50 hover:text-indigo-600'
        }`}
            title="Filter Information"
          >
            <Icons name="info-icon" className="w-6 h-6" />
          </button>
        </div>

        <FormProvider {...methods}>
          <div
            className="formbuilder-wrapper flex flex-col md:flex-row flex-wrap gap-5 w-full
                 border border-dashed border-blue-200 rounded-2xl p-6 bg-white/70
                 hover:bg-blue-50 transition-all duration-300"
          >
            <FormBuilder data={filterFields} edit />
          </div>

          {showInfo && (
            <div className="absolute top-12 right-4 w-64 p-4 bg-gray-100 border border-gray-300 rounded-lg shadow-lg text-sm z-[9]">
              <h4 className="font-semibold mb-2 text-gray-700">
                Filter Information
              </h4>
              <ul className="list-disc pl-4 space-y-1 text-gray-600">
                {filterFields.map((f) => (
                  <li key={f.name}>{f.tagline}</li>
                ))}
              </ul>
            </div>
          )}
        </FormProvider>
      </div>

      <div className="overflow-x-auto">
        <ProgramShedules filters={filters} />
      </div>
    </div>
  )
}
